module.exports = __webpack_public_path__ + "static/media/sleftArrow.11282ecd.svg";